import { inject, Injector, runInInjectionContext } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { environment } from "src/environments/environment";
import { e2eTokenStorageKey } from "../consts/storage-keys";
import { EnvironmentId } from "../enums/environment-id.enum";
import { msalCanActivate } from "./msal.guard";

export const authGuard: CanActivateFn = (...args) => {
  const injector = inject(Injector);
  if (environment.id !== EnvironmentId.Production && sessionStorage.getItem(e2eTokenStorageKey)) {
    return true;
  }
  return runInInjectionContext(injector, () => msalCanActivate(...args));
};
